<template>
  <div>
    <el-card>
      <el-select
        class="m-w"
        v-model="EnterpriseListValue"
        placeholder="请选择企业"
      >
        <el-option
          v-for="item in EnterpriseList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择审核状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="PostName"
        placeholder="请输入岗位名称"
      ></el-input>
      <el-button type="primary" icon="el-icon-plus" @click="onClickAdd"
        >新建</el-button
      >
      <el-button type="primary" @click="GetEP_PostByPage">查询</el-button>

      <el-button @click="clecrData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="MaskName" label="企业社区名称" align="center">
        </el-table-column>
        <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column
          prop="PostEnumTypeName"
          label="岗位类型"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="Phone" label="邮箱" align="center">
        </el-table-column>
        <el-table-column prop="ManageName" label="负责人名称" align="center">
        </el-table-column>
        <el-table-column prop="StatusName" label="状态" align="center">
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Remark"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Remark }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="启用禁用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.IsOpen"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="OC_EP_PostInfo($event, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column label="介绍" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Detail"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Detail }}</div>
            </el-tooltip>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onClickEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              style="color: red"
              @click="onClickDelete(scope.row.Id)"
              >删除</el-button
            >
            <el-button
              type="text"
              @click="onClickAudit(scope.row)"
              v-if="scope.row.Status == 1"
              >去审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="Title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="企业" prop="eP_MaskId" v-if="Title == '新增'">
            <el-select
              class="m-w"
              v-model="ruleForm.eP_MaskId"
              placeholder="请选择企业"
            >
              <el-option
                v-for="item in EnterpriseListCopy"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="岗位名称" prop="postName">
            <el-input
              v-model="ruleForm.postName"
              placeholder="请输入岗位名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责人名称" prop="manageName">
            <el-input
              v-model="ruleForm.manageName"
              placeholder="请输入负责人名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="介绍" prop="detail">
            <quill-editor
              v-model="ruleForm.detail"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption"
            ></quill-editor>
            <el-upload
              class="avatar-uploader1"
              :file-list="[]"
              :action="uploadUrl"
              :shrow-file-list="false"
              :on-success="uploadSuccess"
            />

            <!-- <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="500"
              show-word-limit
              v-model="ruleForm.detail"
              placeholder="请输入detail"
            ></el-input> -->
          </el-form-item>
          <el-form-item label="邮箱" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              maxlength="200"
              show-word-limit
              v-model="ruleForm.remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="
            Title == '新增' ? onSubmitAdd('ruleForm') : onSubmitAdd('ruleForm')
          "
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog title="审核" :visible.sync="dialogVisibleAudit" width="30%">
      <!-- 驳回 -->
      <el-dialog
        title="驳回理由"
        :visible.sync="dialogVisibleReject"
        width="30%"
        append-to-body
      >
        <div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="remark"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onClickCancle">取 消</el-button>
          <el-button
            type="primary"
            @click="ToExamineEP_PostInfo(3, auditItem.Id)"
            >确定驳回</el-button
          >
        </span>
      </el-dialog>
      <div>
        <el-descriptions direction="vertical" :column="1" border>
          <el-descriptions-item label="企业社区名称">{{
            auditItem.MaskName
          }}</el-descriptions-item>
          <el-descriptions-item label="岗位名称">{{
            auditItem.PostName
          }}</el-descriptions-item>
          <el-descriptions-item label="岗位类型">{{
            auditItem.PostEnumTypeName
          }}</el-descriptions-item>
          <el-descriptions-item label="邮箱">
            {{ auditItem.Phone }}
          </el-descriptions-item>
          <el-descriptions-item label="负责人名称">{{
            auditItem.ManageName
          }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{
            auditItem.StatusName
          }}</el-descriptions-item>
          <el-descriptions-item label="备注">{{
            auditItem.Remark
          }}</el-descriptions-item>
          <el-descriptions-item label="介绍">
            <div v-html="auditItem.Detail"></div>
          </el-descriptions-item>
        </el-descriptions>
        <!-- <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入内容"
          v-model="remark"
        >
        </el-input> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleReject = true">驳 回</el-button>
        <el-button type="primary" @click="ToExamineEP_PostInfo(2, auditItem.Id)"
          >通 过</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  Get_MaskSelectInfo,
  GetEP_PostByPage,
  GetCheckStatusSelectInfo,
  AddEP_PostInfo,
  DeleteEP_PostInfo,
  OC_EP_PostInfo,
  ToExamineEP_PostInfo,
} from "../../api/api";

import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ align: [] }],
  ["link", "image"],
  ["clean"], // remove formatting button
];

export default {
  components: { quillEditor },
  data() {
    return {
      tableData: [],
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      EnterpriseList: [],
      EnterpriseListValue: "",
      StatusList: [],
      StatusListValue: "",
      PostName: "",
      Title: "",
      dialogVisible: false,
      ruleForm: {
        id: 0,
        eP_MaskId: "",
        postName: "",
        postEnumType: "0",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
      },
      rules: {
        postName: [
          { required: true, message: "请输入岗位名称", trigger: "blur" },
        ],
        eP_MaskId: [
          { required: true, message: "请选择企业", trigger: "change" },
        ],
        manageName: [
          { required: true, message: "请输入负责人名称", trigger: "blur" },
        ],
        detail: [{ required: true, message: "请输入介绍", trigger: "blur" }],
        phone: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      loading: false,
      dialogVisibleAudit: false,
      remark: "",
      Id: 0,
      EnterpriseListCopy: [],
      uploadUrl: "/api/Img/UploadImg",
      // 富文本编辑器配置
      editorOption: {
        placeholder: "请输入内容",
        theme: "snow", // or 'bubble'
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function (value) {
                if (value) {
                  // 触发input框选择图片文件
                  document.querySelector(".avatar-uploader1 input").click();
                } else {
                  this.quill.format("image", false);
                }
              },
            },
          },
        },
      },
      auditItem: {},
      dialogVisibleReject: false,
    };
  },
  async created() {
    await this.Get_MaskSelectInfo();
    await this.GetCheckStatusSelectInfo();
    await this.GetEP_PostByPage();
  },
  methods: {
    onClickCancle() {
      this.dialogVisibleReject = false;
      this.dialogVisibleAudit = false;
      this.remark = "";
    },
    uploadSuccess(res, file) {
      // res为图片服务器返回的数据
      // 获取富文本组件实例
      let quill = this.$refs.myQuillEditor.quill;
      console.log(res, "res");
      // 如果上传成功
      if (res.success) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.info为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.response);
        // 调整光标到最后
        quill.setSelection(length + 1);
        this.$forceUpdate();
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    async ToExamineEP_PostInfo(status, Id) {
      let res = await ToExamineEP_PostInfo({
        status: status,
        remark: this.remark,
        id: Id,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: status == 2 ? "审核成功" : "驳回成功",
        });
        this.GetEP_PostByPage();
        this.dialogVisibleReject = false;
        this.dialogVisibleAudit = false;
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async onClickAudit(item) {
      this.auditItem = item;
      // 假设富文本内容存在richText变量中
      const richText = item.Detail;
      // 使用正则表达式查找所有的图片标签，并在其上添加 style 属性
      const regExp = /<img(.*?)>/g;
      const processedText = richText.replace(regExp, (match, group) => {
        return `<img${group} style="max-width: 100%; max-height: 100%;"/>`;
      });
      this.auditItem.Detail = processedText;
      this.Id = item.Id;
      this.dialogVisibleAudit = true;
    },
    async OC_EP_PostInfo(e, item) {
      let res = await OC_EP_PostInfo({
        Id: item.Id,
        IsOpen: item.IsOpen ? 1 : 0,
      });
      this.GetEP_PostByPage();
    },
    onClickDelete(Id) {
      this.$confirm("此操作将删除该岗位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DeleteEP_PostInfo({ id: Id });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetEP_PostByPage();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    handleClose() {
      this.clecrData();
      this.dialogVisible = false;
    },
    onClickEdit(item) {
      this.Title = "编辑";
      this.ruleForm = {
        id: item.Id,
        postName: item.PostName,
        postEnumType: "0",
        manageName: item.ManageName,
        detail: item.Detail,
        phone: item.Phone,
        remark: item.Remark,
      };
      this.dialogVisible = true;
    },
    clecrData() {
      this.ruleForm = {
        id: 0,
        eP_MaskId: "",
        postName: "",
        postEnumType: "0",
        manageName: "",
        detail: "",
        phone: "",
        remark: "",
      };
      this.PostName = "";
      this.EnterpriseListValue = "";
      this.StatusListValue = 0;
      this.GetEP_PostByPage();
    },
    onSubmitAdd(formName) {
      this.loading = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await AddEP_PostInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.dialogVisible = false;
            this.loading = false;
            this.$refs[formName].clearValidate();
            this.clecrData();
          } else {
            this.loading = false;

            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onClickAdd() {
      this.Title = "新增";
      this.dialogVisible = true;
    },
    async GetEP_PostByPage() {
      let res = await GetEP_PostByPage({
        PostName: this.PostName,
        MaskId: this.EnterpriseListValue != "" ? this.EnterpriseListValue : -1,
        Status: this.StatusListValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCheckStatusSelectInfo() {
      let res = await GetCheckStatusSelectInfo();
      if (res.data.success) {
        this.StatusList = res.data.response;
        this.StatusListValue = res.data.response[0].Id;
      }
    },
    async Get_MaskSelectInfo() {
      let res = await Get_MaskSelectInfo();
      if (res.data.success) {
        this.EnterpriseList = res.data.response;
        this.EnterpriseListCopy = res.data.response;
      }
    },
    handleSelectionChange(e) {
      console.log(e);
      this.isChange = e;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEP_PostByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetEP_PostByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}

.tui-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/deep/.el-tooltip__popper {
  max-width: 400px;
}

.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>